import TextArea from "antd/lib/input/TextArea";
import React, { useEffect, useState } from "react";
import DeleteIcon from "../../icons/DeleteIcon";

const ParagraphQuestion = ({
  questionId,
  onDelete,
  questionHandler,
  ...rest
}) => {
  const [question, setQuestion] = useState({
    title: "",
    answers: [],
    correct_answers: [],
    sequence: null,
    question_type: "text",
    answer_explanation: null,
  });

  const onChangeHandler = (e, index) => {
    const { name, value } = e.target;

    setQuestion({
      ...question,
      [name]: value,
    });
  };

  useEffect(() => {
    if (question.title) {
      questionHandler(questionId, question);
    }
  }, [question]);

  return (
    <div
      className="bg-white p-4 rounded-3 shadow mb-4 assessment_question"
      {...rest}
    >
      <div className="mb-2"><i>Paragraph question</i></div>
      <div className="d-flex align-items-center justify-content-between">
        <TextArea
          type="text"
          name="title"
          autoSize={{minRows:1}}
          onChange={onChangeHandler}
          placeholder="Question Title"
          className="w-75 ant-input assessment_question_title"
        />

        <DeleteIcon width="18" height="18" onClick={onDelete} />
      </div>
    </div>
  );
};

export default React.memo(ParagraphQuestion);
